import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { VendorProvider } from './context/VendorContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import VendorListPage from './pages/VendorListPage';
import AboutPage from './pages/AboutPage';
import CategoryPage from './pages/CategoryPage';
import VendorRegistrationPage from './pages/VendorRegistrationPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import GrievancePolicyPage from './pages/GrievancePolicyPage';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <VendorProvider>
          <Router>
            <ScrollToTop />
            <div className="min-h-screen flex flex-col" style={{backgroundColor: '#FAF9F6'}}>
              <Navbar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/vendors" element={<VendorListPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/register-vendor" element={<VendorRegistrationPage />} />
                  
                  {/* Legal Pages */}
                  <Route path="/terms-of-use" element={<TermsOfUsePage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                  <Route path="/grievance-policy" element={<GrievancePolicyPage />} />
                  
                  {/* Dynamic Category Route */}
                  <Route path="/category/:categorySlug" element={<CategoryPage />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </VendorProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;